import { Swiper, SwiperSlide } from "swiper/react"

import { Color } from "../../../constants/V2/color"
import LayoutSection from "../LayoutComponents/LayoutSection"
import LayoutItem from "../Layouts/LayoutItem"

import PillButton from "@components/elements/V2/Buttons/PillButton"
import AccordionArrowIcon from "@components/elements/V2/Icons/AccordionArrowIcon"
import Typography from "@components/elements/V2/Typography"
import { storyblokHorizontalGutterClasses } from "@constants/spacing"
import { getAccentColor } from "@utils/V2/color"
import React from "react"

type NavigationBannerProps = {
  superscript: string
  title: string
  description: string
  backgroundColor?: Color
  navigationItems: Storyblok.NavigationBannerItem[]
  mobileGridOrder?: number
  id?: string
}

const NavigationBanner = ({
  title,
  description,
  backgroundColor = Color.Charcoal,
  navigationItems,
  mobileGridOrder,
  id,
  ...props
}: NavigationBannerProps) => {
  return (
    <LayoutItem
      as={LayoutSection}
      className="overflow-hidden"
      primaryBackgroundColor={backgroundColor}
      mobileGridOrder={mobileGridOrder}
      id={id}
      {...props}
    >
      <div className="flex w-full flex-col gap-8 pb-20 md:w-5/6 md:pb-40">
        <Typography
          text={title}
          font="grotesk"
          weight="book"
          size="h3"
          color={getAccentColor(backgroundColor)}
        />
        <Typography
          text={description}
          font="grotesk"
          weight="book"
          size="body-lg"
          color={getAccentColor(backgroundColor)}
          className="opacity-80"
        />
      </div>
      <div className="-mx-gutter-xs py-10 sm:-mx-gutter-sm md:-mx-gutter-md md:py-0 md:pb-10 lg:-mx-gutter-lg xl:-mx-gutter-xl 4k:-mx-gutter-4k">
        <Swiper
          className={storyblokHorizontalGutterClasses}
          spaceBetween={10}
          slidesPerView="auto"
          watchOverflow
        >
          {navigationItems.map((item, index) => {
            return (
              <SwiperSlide className="!w-fit" key={`${item.anchorId}-${index}`}>
                <PillButton
                  style="bordered"
                  size="small"
                  color={getAccentColor(backgroundColor)}
                  overrideTextColor={getAccentColor(backgroundColor)}
                  text={item.title}
                  className="border-opacity-20"
                  fontSize="body-sm"
                  linkUrl={
                    item.anchorId && item.anchorId.startsWith("#")
                      ? item.anchorId
                      : `#${item.anchorId}`
                  }
                  icon={<AccordionArrowIcon open={false} />}
                  transparentHover={true}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </LayoutItem>
  )
}

export default NavigationBanner
